// Regras puras dos pacotes de crédito SMS: preço unitário, destaque do
// melhor custo-benefício e saldo resultante da compra.
// Sem React — testado em __tests__/smsRules.test.js.

// `valor` vem do Sequelize como string (DECIMAL) — sempre passar por Number.
export const packPrice = (pack) => {
  const value = Number(pack?.valor);
  return Number.isFinite(value) ? value : 0;
};

export const packQuantity = (pack) => {
  const qty = Number(pack?.quantidade);
  return Number.isFinite(qty) ? qty : 0;
};

// Preço por SMS. Devolve null quando a quantidade é zero, para a tela omitir
// a linha em vez de exibir "Infinity" ou "R$ NaN".
export const unitPrice = (pack) => {
  const qty = packQuantity(pack);
  if (qty <= 0) return null;
  return packPrice(pack) / qty;
};

// Id do pacote com o menor preço por SMS — ganha o selo do mockup. Com menos
// de dois pacotes não há comparação a fazer, então ninguém é destacado.
export const bestValuePackId = (packs = []) => {
  const withUnit = packs
    .map((pack) => ({ id: pack?.id, unit: unitPrice(pack) }))
    .filter((entry) => entry.unit !== null && entry.id !== undefined);

  if (withUnit.length < 2) return null;

  return withUnit.reduce((best, entry) =>
    entry.unit < best.unit ? entry : best
  ).id;
};

// Resumo do rodapé: total e saldo depois da compra.
export const purchaseSummary = (pack, currentBalance) => {
  if (!pack) return null;
  const qty = packQuantity(pack);
  const total = packPrice(pack);
  // `Number(null)` é 0 — testar antes de converter, senão saldo desconhecido
  // vira zero e a tela "inventa" um novo saldo que não corresponde a nada.
  const knownBalance =
    currentBalance === null || currentBalance === undefined || currentBalance === ""
      ? null
      : Number(currentBalance);
  return {
    quantity: qty,
    total,
    unit: unitPrice(pack),
    newBalance:
      knownBalance !== null && Number.isFinite(knownBalance)
        ? knownBalance + qty
        : null,
  };
};

export const formatBRL = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

// Preço por SMS costuma ter mais de duas casas (R$ 0,085) — arredondar para
// centavos mostraria "R$ 0,09" e a conta do total pareceria errada.
export const formatUnit = (value) =>
  value === null || value === undefined
    ? null
    : Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      });
